import { useTranslation } from 'react-i18next';

/**
 * 4 語系切換（en / zh-TW / fr-CA / es-MX）。
 * 直接呼叫 i18next.changeLanguage，並同步 <html lang="...">。
 * fr-CA 是 Quebec Law 25 合規必要語系；es-MX 給北美西語人口。
 */
const VISIBLE_LANGS = ['en', 'zh-TW', 'fr-CA', 'es-MX'] as const;

export default function LangSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language ?? 'en';

  return (
    <div
      role="radiogroup"
      aria-label="Language"
      className="flex items-center gap-1 rounded-full border border-border bg-surface/80 p-1 text-xs backdrop-blur"
    >
      {VISIBLE_LANGS.map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            role="radio"
            aria-checked={active}
            onClick={() => {
              void i18n.changeLanguage(lng);
              document.documentElement.setAttribute('lang', lng);
            }}
            className={[
              'rounded-full px-3 py-1 transition-colors',
              active ? 'bg-fg text-bg' : 'text-muted hover:text-fg',
            ].join(' ')}
          >
            {t(`common.langs.${lng}`)}
          </button>
        );
      })}
    </div>
  );
}
